var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.639545 14.6456H0.607568C0.500977 14.6456 0.394386 14.6136 0.287796 14.5497C0.245159 14.507 0.202523 14.4644 0.159886 14.4217C0.0532956 14.2938 0 14.1446 0 13.9741V0.671523C0 0.500977 0.0639546 0.35175 0.191864 0.223842C0.319773 0.0746138 0.469 0 0.639545 0H4.6367C4.82857 0 4.98845 0.063955 5.11636 0.191865L6.26754 1.31107H16.6282C16.82 1.31107 16.9799 1.37502 17.1078 1.50293C17.2357 1.63084 17.2997 1.79073 17.2997 1.98259V3.99716H19.3143C19.5274 3.99716 19.698 4.08243 19.8259 4.25298C19.9751 4.42352 20.0284 4.61539 19.9858 4.82857L17.2997 14.1659C17.2571 14.3152 17.1718 14.4324 17.0439 14.5177C16.916 14.6029 16.7774 14.6456 16.6282 14.6456H0.639545ZM1.59886 13.3025H16.1485L18.4189 5.30823H4.44484L1.59886 13.3025ZM1.31107 1.31107V10.1368L3.35761 4.44484C3.40025 4.31693 3.47486 4.21034 3.58145 4.12507C3.70936 4.03979 3.84793 3.99716 3.99716 3.99716H15.9886V2.65411H5.97975C5.78788 2.65411 5.628 2.59016 5.50009 2.46225L4.38088 1.31107H1.31107Z",
    fill: "#53565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.933f09642a8c6c02d3ad8e31e533b912.svg";
export { ForwardRef as ReactComponent };